module.exports = __webpack_public_path__ + "static/media/sample_bulk_mark_destination.5e507260.csv";